import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";
import _ from "lodash";

interface IState {
    brands: string[];
    error?: boolean;
    isFetchingBrand: boolean;
    isFetchingBrands: boolean;
    brandFetched: boolean;
    meta?: any;
}

const initialState: IState = {
    brands: [],
    error: undefined,
    isFetchingBrand: false,
    isFetchingBrands: false,
    brandFetched: false,
    meta: undefined,
};

export const collectionSidePanel = handleActions(
    {
        [COLLECTIONS.COLLECTION_SIDE_PANEL.BRAND.FETCH.START]: (state: IState) => {
            return {
                ...state,
                isFetchingBrand: true,
            };
        },
        [COLLECTIONS.COLLECTION_SIDE_PANEL.BRAND.FETCH.COMPLETED]: (state: IState) => {
            return {
                ...state,
                isFetchingBrand: false,
            };
        },
        [COLLECTIONS.COLLECTION_SIDE_PANEL.BRANDS.FETCH.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetchingBrands: false,
                };
            }
            const modifiedPayload = payload.filter((item) => item.length !== 0);
            return {
                ...state,
                brands: state.brands?.length ? _.uniq([...state.brands, ...modifiedPayload]) : modifiedPayload,
                isFetchingBrands: false,
            };
        },
        [COLLECTIONS.COLLECTION_SIDE_PANEL.SINGLE_BRAND.FETCH.COMPLETED]: (state: IState) => {
            return {
                ...state,
                isFetchingBrand: false,
                brandFetched: true,
            };
        },
    },
    initialState,
);
